// Change class of all largeGridItems with class "medium-up--one-quarter" to "medium-up--one-third" and vice versa on button click
// function fourToThreeGrid() {
//   const largeGridItems = document.getElementsByClassName("grid-product");

//   if (document.getElementById("gridButton-ftt").classList.contains("gridButton--active")) {
//     if (document.getElementById("gridButton-tto").classList.contains("gridButton--active")){
//     return;
//     }
//   }

//   Array.from(largeGridItems).forEach(function(item) {
//     if (item.classList.contains("medium-up--one-quarter")) {
//       item.classList.replace("medium-up--one-quarter", "medium-up--one-third");
//       item.setAttribute("data-aos", "row-of-3");
//     } else if (item.classList.contains("medium-up--one-third")) {
//       item.classList.replace("medium-up--one-third", "medium-up--one-quarter");
//       item.setAttribute("data-aos", "row-of-4");
//     }

//     if (item.classList.contains("small--one-half")) {
//       item.classList.replace("small--one-half", "small--one-whole");
//     }
//   });

//   document.getElementById("gridButton-ftt").classList.add("gridButton--active");
//   document.getElementById("gridButton-tto").classList.add("gridButton--active");
//   document.getElementById("gridButton-ttf").classList.remove("gridButton--active");
//   document.getElementById("gridButton-ott").classList.remove("gridButton--active");
//   document.querySelector(".gridswitch_wrapper").classList.add("three-in-row");
//   document.querySelector(".gridswitch_wrapper").classList.remove("four-in-row");
//   console.log(document.getElementById("gridButton-ott"))
//   console.log(document.getElementById("gridButton-tto"))
// }

// // Change class of all elements with class "medium-up--one-third" to "medium-up--one-quarter" and vice versa on button click
// const smallGridItems = document.getElementsByClassName("grid-product");

// function threeToFourGrid() {
//   if (document.getElementById("gridButton-ttf").classList.contains("gridButton--active")) {
//     if (document.getElementById("gridButton-ott").classList.contains("gridButton--active")){
//     return;
//     }
//   }

//   Array.from(smallGridItems).forEach(function(item) {
//     if (item.classList.contains("medium-up--one-third")) {
//       item.classList.replace("medium-up--one-third", "medium-up--one-quarter");
//       item.setAttribute("data-aos", "row-of-4");
//       item.querySelector('image-element').classList.add('aos-animate');
//     } else if (item.classList.contains("medium-up--one-quarter")) {
//       item.classList.replace("medium-up--one-quarter", "medium-up--one-third");
//       item.setAttribute("data-aos", "row-of-3");
//     }

//     if (item.classList.contains("small--one-whole") && !item.classList.contains("grid-promo-block")) {
//       item.classList.replace("small--one-whole", "small--one-half");
//       item.setAttribute("data-aos", "row-of-4");
//     }
//   });

//   document.getElementById("gridButton-ttf").classList.add("gridButton--active");
//   document.getElementById("gridButton-ott").classList.add("gridButton--active");
//   document.getElementById("gridButton-ftt").classList.remove("gridButton--active");
//   document.getElementById("gridButton-tto").classList.remove("gridButton--active");
//   document.querySelector(".gridswitch_wrapper").classList.add("four-in-row");
//   document.querySelector(".gridswitch_wrapper").classList.remove("three-in-row");
//   console.log(document.getElementById("gridButton-ott"))
//   console.log(document.getElementById("gridButton-tto"))
// }


// const FloatLabel = (() => {
//   const handleFocus = (e) => {
//     const target = e.target;
//     target.parentNode.classList.add('active-field');
//     console.log()
//   };

//   const handleBlur = (e) => {
//     const target = e.target;
//     if (!target.value) {
//       target.parentNode.classList.remove('active-field');
//     }
//   };

//   const bindEvents = (element) => {
//     const floatField = element.querySelector('input, textarea');
//     floatField.addEventListener('focus', handleFocus);
//     floatField.addEventListener('blur', handleBlur);
//   };

//   const init = () => {
//     const floatContainers = Array.from(document.querySelectorAll('.form-input-container'));

//     floatContainers.forEach((element) => {
//       const inputField = element.querySelector('input, textarea');

//       if (inputField.value || inputField.hasAttribute('autofocus')) {
//         element.classList.add('active-field');
//       }

//       bindEvents(element);
//     });
//   };

//   return {
//     init: init,
//   };
// })();

// FloatLabel.init();

// var textarea = document.querySelectorAll(".autoresizing");
// textarea.forEach(element => {
//   element.addEventListener('input', autoResize, false);
// });

// function autoResize() {
//     this.style.height = 'auto';
//     this.style.height = this.scrollHeight + 'px';
// }



function fourToThreeGrid() {
  const largeGridItems = document.getElementsByClassName("grid-product");

  if (document.getElementById("gridButton-ftt").classList.contains("gridButton--active")) {
    if (document.getElementById("gridButton-tto").classList.contains("gridButton--active")){
      return;
    }
  }

  Array.from(largeGridItems).forEach(function(item) {
    if (item.classList.contains("medium-up--one-quarter")) {
      item.classList.replace("medium-up--one-quarter", "medium-up--one-third");
      item.setAttribute("data-aos", "row-of-3");
    } else if (item.classList.contains("medium-up--one-third")) {
      item.classList.replace("medium-up--one-third", "medium-up--one-quarter");
      item.setAttribute("data-aos", "row-of-4");
    }

    if (item.classList.contains("small--one-half")) {
      item.classList.replace("small--one-half", "small--one-whole");
    }
  });

  document.getElementById("gridButton-ftt").classList.add("gridButton--active");
  document.getElementById("gridButton-tto").classList.add("gridButton--active");
  document.getElementById("gridButton-ttf").classList.remove("gridButton--active");
  document.getElementById("gridButton-ott").classList.remove("gridButton--active");
  document.querySelector(".gridswitch_wrapper").classList.add("three-in-row");
  document.querySelector(".gridswitch_wrapper").classList.remove("four-in-row");

  updateFlickityGrid();
}

const smallGridItems = document.getElementsByClassName("grid-product");

function threeToFourGrid() {
  if (document.getElementById("gridButton-ttf").classList.contains("gridButton--active")) {
    if (document.getElementById("gridButton-ott").classList.contains("gridButton--active")){
      return;
    }
  }

  Array.from(smallGridItems).forEach(function(item) {
    if (item.classList.contains("medium-up--one-third")) {
      item.classList.replace("medium-up--one-third", "medium-up--one-quarter");
      item.setAttribute("data-aos", "row-of-4");
      item.querySelector('image-element').classList.add('aos-animate');
    } else if (item.classList.contains("medium-up--one-quarter")) {
      item.classList.replace("medium-up--one-quarter", "medium-up--one-third");
      item.setAttribute("data-aos", "row-of-3");
    }

    if (item.classList.contains("small--one-whole") && !item.classList.contains("grid-promo-block")) {
      item.classList.replace("small--one-whole", "small--one-half");
      item.setAttribute("data-aos", "row-of-4");
    }
  });

  document.getElementById("gridButton-ttf").classList.add("gridButton--active");
  document.getElementById("gridButton-ott").classList.add("gridButton--active");
  document.getElementById("gridButton-ftt").classList.remove("gridButton--active");
  document.getElementById("gridButton-tto").classList.remove("gridButton--active");
  document.querySelector(".gridswitch_wrapper").classList.add("four-in-row");
  document.querySelector(".gridswitch_wrapper").classList.remove("three-in-row");

  updateFlickityGrid();
}

// Float Label Handling
const FloatLabel = (() => {
  const handleFocus = (e) => {
    const target = e.target;
    target.parentNode.classList.add('active-field');
  };

  const handleBlur = (e) => {
    const target = e.target;
    if (!target.value) {
      target.parentNode.classList.remove('active-field');
    }
  };

  const bindEvents = (element) => {
    const floatField = element.querySelector('input, textarea');
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);
  };

  const init = () => {
    const floatContainers = Array.from(document.querySelectorAll('.form-input-container'));

    floatContainers.forEach((element) => {
      const inputField = element.querySelector('input, textarea');
      if (inputField.value || inputField.hasAttribute('autofocus')) {
        element.classList.add('active-field');
      }
      bindEvents(element);
    });
  };

  return {
    init: init,
  };
})();
FloatLabel.init();

// Auto Resize Textareas
var textarea = document.querySelectorAll(".autoresizing");
textarea.forEach(element => {
  element.addEventListener('input', autoResize, false);
});
function autoResize() {
  this.style.height = 'auto';
  this.style.height = this.scrollHeight + 'px';
}

// Flickity Resize Helpers
function refreshFlickityHeight() {
  const flickityContainers = document.querySelectorAll('.product_image_slider');
  flickityContainers.forEach(slider => {
    const flkty = Flickity.data(slider);
    if (flkty) {
      flkty.resize();
    }
  });
}

function updateSlideHeights() {
  const slides = document.querySelectorAll('.image-wrap_slide');

  slides.forEach(slide => {
    const img = slide.querySelector('img');
    if (!img) return;

    const adjust = () => {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      const width = slide.offsetWidth;
      const newHeight = width / aspectRatio;
      slide.style.height = `${newHeight}px`;
    };

    if (img.complete && img.naturalHeight > 0) {
      adjust();
    } else {
      img.addEventListener('load', adjust);
    }
  });
}

function updateFlickityGrid() {
  updateSlideHeights();
  refreshFlickityHeight();
  setTimeout(refreshFlickityHeight, 300); // for good measure if lazy-loaded
}





// Its html is on product description snippet
// document.addEventListener("DOMContentLoaded", function () {
//   // Assuming you have a list of variant elements with a class "label_variant" and a "data-shipping" attribute.
//   const variants = document.querySelectorAll('.label_variant');
//   const metaContentElement = document.querySelector('.meta_content');

//   // Function to update meta content based on the selected variant
//   function updateMetaContent(variant) {
//     const dataShipping = variant.getAttribute('data-shipping');

//     if (dataShipping !== null) {
//       // Display the data-shipping content in the .meta_content element.
//       if (metaContentElement) {
//         metaContentElement.textContent = dataShipping;
//       }
//     } else {
//       // Handle the case where the selected variant does not have a data-shipping attribute.
//       console.log('No data-shipping attribute found for this variant.');
//     }
//   }

//   // Find the initially selected variant based on some criteria (e.g., a specific class)
//   const initiallySelectedVariant = document.querySelector('.label_variant.initially-selected');

//   // Update the meta content based on the initially selected variant
//   if (initiallySelectedVariant) {
//     updateMetaContent(initiallySelectedVariant);
//   }

//   // Add click event listeners to the variants
//   variants.forEach(function (variant) {
//     variant.addEventListener('click', function () {
//       // Remove the "initially-selected" class from all variants
//       variants.forEach(function (v) {
//         v.classList.remove('initially-selected');
//       });

//       // Add the "initially-selected" class to the clicked variant
//       this.classList.add('initially-selected');

//       // Update the meta content based on the clicked variant
//       updateMetaContent(this);
//     });
//   });
// });




var metaContentElement = document.querySelector('.meta_content');

document.addEventListener('variant:change', function (evt) {
  currentVariant = evt.detail.variant;
  shippingTime = variantMF[currentVariant.id][1]

  if (metaContentElement) {
    metaContentElement.textContent = shippingTime;
  }
  if (currentVariant.available) {
    metaContentElement.parentElement.classList.remove("hide")
  }
  else {
    metaContentElement.parentElement.classList.add("hide")
  }

});

document.addEventListener('DOMContentLoaded', function () {
  console.log(metaContentElement)
  if (metaContentElement) {
    metaContentElement.textContent = shippingTime;
  }
});